module.exports = __webpack_public_path__ + "static/img/video_4.31f406f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_4.jpg
// module id = sY6V
// module chunks = 1